import type { SiteName } from '@/scopes/common/domain/types'

const SITES_WITH_PRODUCT_CARD_AIRPORT_DROPDOWN: readonly SiteName[] = ['sunwebnl', 'elizanl']

export function shouldShowProductCardAirportDropdown(siteName: SiteName): boolean {
  return SITES_WITH_PRODUCT_CARD_AIRPORT_DROPDOWN.includes(siteName)
}
